import { render, staticRenderFns } from "./AmioSidebar.vue?vue&type=template&id=4a5d76ac&scoped=true&"
import script from "./AmioSidebar.vue?vue&type=script&lang=js&"
export * from "./AmioSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AmioSidebar.vue?vue&type=style&index=0&id=4a5d76ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d76ac",
  null
  
)

export default component.exports